<footer class="bg-dark sticky-footer">
  <div class="container my-auto">
    <div class="text-center my-auto copyright"><span>Copyright © Le Coffre-Fort Numérique {{currentYear}}</span></div>
  </div>
</footer>
